import useCollapse from "react-collapsed";
import { chevron_down, chevron_up } from "./../../pngs";
import { TermsAndConditions, getImg } from "../../utils";
import "./CoalitionCollapsible.scss";

export const CoalitionCollapsible = ({ terms = null }) => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  return (
    <>
      {terms ? (
        <div className="collapsible-item collapsible">
          <div
            className={`header collapsible-${isExpanded ? "open" : "closed"}`}
            {...getToggleProps()}
          >
            Términos y Condiciones
            <span>{getImg(isExpanded ? chevron_up : chevron_down)}</span>
          </div>
          <div {...getCollapseProps()}>
            <TermsAndConditions terms={terms} />
          </div>
        </div>
      ) : null}
    </>
  );
};
